export const RouterConst = {
  Dashboard: 'dashboard',
  Assets: 'assets',
  Enrolment: 'enrolment',
  Governance: 'governance',
  OrganizationManagement: 'governance/organizations',
  ApplicationManagement: 'governance/applications',
  RoleManagement: 'governance/roles',
  SearchResult: 'search-result',
  Enrol: 'enrol',
  Welcome: 'welcome',
  VerifiablePresentation: 'vp',

  AssetEnrolment: '/assets/enrolment/',
  RegisterAsset: 'register',
  MyEnrolments: '/enrolment?selectedTab=1',
  EnrolmentDetails: 'enrolment/:subject',

  ReturnUrl: 'returnUrl',
  QRScan: 'qr-scan',
};
